import axios from 'axios';

const lottery_types = {
  1: 'gd_ha10',
  2: 'cc_ssc',
  3: 'pk10'
};

const cache = {};

export const getLotteryTypes = () => {
  const url = '/ssc_golang/v1/lottery/types';
  if (cache[url]) return cache[url];

  return axios.get(url).then(info => {
    if (info.result === 'ok') {
      info.data = info.data.map((item, index) => {
        item.top = item.lottery_name.substring(0, 2);
        item.b = item.lottery_name.substring(2);
        item.active = true;
        item.title = item.lottery_name;
        item.path = item.url;
        if (!item.id) item.id = item.lottery_type;

        // 非外部链接
        if (!/^https?/.test(item.path) && lottery_types[item.category]) {
          // 判断类型
          const query = [
            `lottery_type=${item.lottery_type}`,
            `category_id=${item.category}`
          ];
          item.path = '/home/' + lottery_types[item.category] + '?' + query.join('&');
        }
        return item;
      });

      cache[url] = info;
    }

    return info;
  });
};

//首页游戏类别
export const getDownCount = lottery_type => {
  const url = `/ssc_golang/v1/lottery/countdown?lottery_type=` + lottery_type;
  return axios.get(url).then(res => {
    return res.data;
  })
}


// 获取子玩法列表
export const getLotteryChildData = id => {
  const url = `/ssc_golang/v1/lottery/category/${id}`;
  if (cache[url]) return cache[url];
  return axios.get(url).then(info => {
    if (info.result === 'ok') {
      info.data = info.data.map(item => {
        return {
          ...item,
          value: item.sub_category_id,
          label: item.sub_category_name
        };
      });
      cache[url] = info;
    }
    return info;
  });
};


// 获取当前玩法赔率
export const getOddsData = ({category_id, sub_category_id, lottery_type, played_name}) => {
  const params = (() => {
    const p = {
      category_id,
      sub_category_id,
      lottery_type,
      played_name
    };
    const ps = [];
    for (let i in p) ps.push(`${i}=${p[i]}`);
    return ps;
  })();
  const url = `/ssc_golang/v1/odds/mobile?${params.join('&')}`;
  return axios.get(url).then(info => {
    if (info.result === 'ok') cache[url] = info;
    return info;
  });
};


// 开奖历史结果查询
export const getLotteryResults = ({lottery_type, result_date}) => {
  return axios.get('/ssc_golang/v1/results', {
    params: {
      lottery_type,
      result_date
    }
  }).then(info => {
    if (info.result === 'ok') info.data = info.data || [];
    return info;
  });
};

// 获取最新投注
export const getLotteryLatest = () => {
  return axios.get('/ssc_golang/v1/order/latest');
};

// 最新彩种开奖结果查询
// 历史开奖结果
const res_cache = {};

export const getNewLotteryRes = async ({sub_category_id,lottery_type}) => {
  const key = `/ssc_golang/v1/lottery_${lottery_type}`;
  let info = await axios.get('/ssc_golang/v1/lottery', {params: {sub_category_id,lottery_type}});

  // 当前时间
  const now = Date.now();

  // info.data.next_info.block_time = 5;
  // info.data.next_info.remain_time = 10;

  /***
   * 如果存在上一次开奖结果
   * 并且这次请求的开奖结果和上一次开奖结果一致
   * 认定为当前次开奖结果还没同步开奖，轮询开奖结果
   * 停止条件：当前结果已经不存在，或者下一期开奖已经不存在，或者当前开奖结果和上一次的开奖结果不一致，或返回的上一次开奖和当前开奖qishu
   */
  if (
    res_cache[key] &&
    info.result === 'ok' &&
    info.data &&
    info.data.latest_result &&
    info.data.next_info
  ) {
    const isNotDraw = (
      res_cache[key] &&
      res_cache[key].latest_result &&
      res_cache[key].latest_result.period === info.latest_result.period
    );

    const isDrawing = (info.data.latest_result.period === info.data.next_info.period) || (!info.data.next_info.block_time || info.data.next_info.remain_time <= 1);

    /*if (isNotDraw || isDrawing) info = await new Promise(resolve => {
      setTimeout(async () => {
        const info = await getNewLotteryRes(lottery_type);
        resolve(info);
      }, 3000);
    });*/

    info.data.next_info.timestamp *= 1000;
    info.data.next_info.timestamp += (Date.now() - now);

    return info;
  }

  res_cache[key] = info;


  if (
    info.result === 'ok' &&
    info.data &&
    info.data.latest_result &&
    info.data.next_info
  ) {
    info.data.next_info.timestamp *= 1000;
    info.data.next_info.timestamp += (Date.now() - now);
  }

  return info;
};

// 投注
export const createLotteryOrder = ({category_id, sub_category_id, lottery_type, period, data}) => {
  if (data instanceof Array) data = JSON.stringify(data);
  return axios.post('/ssc_golang/v1/order/create', {
    category_id, sub_category_id, lottery_type, period, data
  });
};

// 长龙排行榜
export const getLongQueue = lottery_type => {
  return axios.get('/ssc_golang/v1/results/longqueue', {params: {lottery_type}});
};


export const getRule = lottery_type => {
  return axios.get('ssc_golang/v1/lottery/rule', {params: {lottery_type}});
};

// 获取生肖
export const getShengxiao = () => {
  return axios.get('ssc_golang/v1/lottery/animals', {});
};



// WEBPACK FOOTER //
// ./src/service/lottery.js